<template>
  <dashboard-page title="Clientes">
    <div class="content">
    <base-header class="pb-6">
      <b-row>
        <b-col class="col-12 col-lg-4 mt-2">
          <TotalClientsCard />
        </b-col>

        <b-col class="col-12 col-lg-4 mt-2">
          <TotalToBeReceivedCard />
        </b-col>

        <b-col class="col-12 col-lg-4 mt-2">
          <AvarageTimePaymentCard />
        </b-col>
      </b-row>
    </base-header>

    <b-container class="mt--6" fluid>
      <div>
        <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
          <div>
            <b-col cols="12" class="d-flex justify-content-center justify-content-sm-between flex-wrap">
              <b-col cols="12" class="d-flex justify-content-center justify-content-sm-between flex-wrap">
                <el-select class="select-primary pagination-select" v-model="pagination.perPage" placeholder="Per page">
                  <el-option class="select-primary" v-for="item in pagination.perPageOptions" :key="item" :label="item"
                    :value="item">
                  </el-option>
                </el-select>

                <div>
                  <base-input v-model="searchQuery" prepend-icon="fas fa-search" placeholder="Nome, CPF ou CNPJ">
                  </base-input>
                </div>
              </b-col>
            </b-col>

            <el-table v-loading="tableLoading" :data="queriedData" row-key="id" header-row-class-name="thead-light"
              @sort-change="sortChange" @selection-change="selectionChange">
              <el-table-column v-for="column in clientsTableColumns" :key="column.label" v-bind="column">
              </el-table-column>

              <el-table-column width="auto" align="right" label="Ações">
                <div slot-scope="{ $index, row }" class="d-flex">
                  <base-button @click.native="handleView($index, row)" class="details" type="info" size="sm" icon>
                    <i class="text-white fas fa-eye"></i>
                  </base-button>
                  <!-- <base-button
                    @click.native="handleEdit($index, row)"
                    class="edit"
                    type="warning"
                    size="sm"
                    icon
                  >
                    <i class="text-white fas fa-user-edit"></i>
                  </base-button>
                  <base-button
                    @click.native="handleDelete($index, row)"
                    class="remove btn-link"
                    type="danger"
                    size="sm"
                    icon
                  >
                    <i class="text-white fas fa-trash-alt"></i>
                  </base-button> -->
                </div>
              </el-table-column>
            </el-table>
          </div>

          <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
            <div class="">
              <p class="card-category">
                Mostrando <b>{{ from + 1 }}</b> a {{ to }} de
                <b>{{ total }}</b> clientes

                <span v-if="selectedRows.length">
                  &nbsp; &nbsp; {{ selectedRows.length }} item(s) selecionado(s)
                </span>
              </p>
            </div>

            <base-pagination class="pagination-no-border" :current="pagination.currentPage"
              :per-page="pagination.perPage" :total="total" @change="paginationChanged($event)">
            </base-pagination>
          </div>

          <b-modal v-modal="openClientModal" :size="'xl'">
            <template v-if="client != null" #modal-header>
              <h2 align-v="start" class="card-header w-100">{{ client.n }}</h2>
            </template>

            <ClientModal :client="client" :isMobile="mobileMode" />
          </b-modal>
        </card>
      </div>
    </b-container>
  </div>
  </dashboard-page>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { isMobile } from '@/store/utils/general'
import Card from "@/components/Cards/Card.vue"
import BaseHeader from "@/components/BaseHeader.vue"
import { Table, TableColumn, Select, Option } from "element-ui"
import { BasePagination } from "@/components"
import clientPaginationMixin from "./../Tables/PaginatedTables/clientPaginationMixin"
import ClientModal from "@/views/Clients/components/ClientModal.vue"
import { Modal } from "@/components"
import TotalClientsCard from './components/TotalClientsCard.vue'
import TotalToBeReceivedCard from './components/TotalToBeReceivedCard.vue'
import AvarageTimePaymentCard from './components/AvarageTimePaymentCard.vue'

export default {
  mixins: [clientPaginationMixin],
  components: {
    Card,
    BaseHeader,
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    ClientModal,
    Modal,
    TotalClientsCard,
    TotalToBeReceivedCard,
    AvarageTimePaymentCard,
  },
  data() {
    return {
      selectedRows: [],
      formattedBillItems: [],
      clientsTableColumns: [
        { type: "selection" }, { prop: "name", label: "Nome", minWidth: 100, sortable: true, },
        { prop: "cpf", label: "CPF", minWidth: 100, sortable: true, }
      ],
      products: [],
      productsMap: [],
      openClientModal: false,
      client: null,
      tableLoading: false,
      mobileMode: isMobile()
    };
  },

  computed: {
    ...mapState('client', ['clients'])
  },

  methods: {
    ...mapActions('client', ['getAllClients', 'getServicesPendecies']),

    ...mapActions('product', ['loadProducts', 'loadProductsMap']),

    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },

    paginationChanged(page) {
      this.pagination.currentPage = page;
    },

    handleView(index, client) {
      this.client = client;
      this.openClientModal = true;
    },

    async populateTable() {
      try {
        this.tableLoading = true;
        this.formattedBillItems = [...this.clients];
      } catch (error) {
      } finally {
        this.tableLoading = false;
      }
    },
  },

  async mounted() {
    await this.loadProductsMap()

    await this.loadProducts().then((rsp) => {
      this.products = rsp.list
      this.loading = false
    })

    await this.getAllClients()
    await this.populateTable()
    await this.createFuseSearch(["name", "cpf"])
  }
}
</script>
